module.exports = __webpack_public_path__ + "img/logoBlue.92549769.svg";